import api from '@/lib/axios'

export interface Project {
  id: string
  org_id: string
  name: string
  description: string | null
  system_prompt: string | null
  summary_prompt: string | null
  is_archived: boolean
  created_by: string
  created_at: string
  updated_at: string
  document_count: number
  field_count: number
}

export const projectsApi = {
  list: () => api.get<Project[]>('/projects').then((r) => r.data),

  create: (data: { name: string; description?: string; system_prompt?: string }) =>
    api.post<Project>('/projects', data).then((r) => r.data),

  get: (id: string) => api.get<Project>(`/projects/${id}`).then((r) => r.data),

  update: (id: string, data: Partial<Project>) =>
    api.patch<Project>(`/projects/${id}`, data).then((r) => r.data),

  delete: (id: string) => api.delete(`/projects/${id}`).then((r) => r.data),

  duplicate: (id: string, data: { name?: string; copy_documents?: boolean }) =>
    api.post<Project>(`/projects/${id}/duplicate`, data).then((r) => r.data),
}
